import React from 'react';
import { useGlobal } from '@rcg/ui-react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// eslint-disable-next-line import/no-extraneous-dependencies
import clsx from 'clsx';
import {
  Box,
  Divider,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Hidden,
  Typography,
} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { formatPrice } from '@rcg/pricing-format';
import useStyles from './index.style';
import { ReactComponent as CreditCarardIcon } from '../../assets/svg/credit_card_icon.svg';
import { ReactComponent as AmericanExpress } from '../../assets/svg/credit-card-american-express.svg';
import { ReactComponent as DinersClub } from '../../assets/svg/credit-card-diners-club.svg';
import { ReactComponent as Discover } from '../../assets/svg/credit-card-discover.svg';
import { ReactComponent as Jcb } from '../../assets/svg/credit-card-jcb.svg';
import { ReactComponent as MasterCard } from '../../assets/svg/credit-card-mastercard.svg';
import { ReactComponent as Visa } from '../../assets/svg/credit-card-visa.svg';

const setClasses = (classNewLayout, classes, price) => {
  const column = classNewLayout ? classes.columnNewLayout : classes.column;
  let heading = classNewLayout ? classes.headingNewLAyout : classes.heading;
  let viewPanel = classNewLayout ? classes.viewPanelNewLayout : classes.viewPanel;
  const root = classNewLayout ? classes.rootNewLayout : classes.root;
  let panelSummary = classNewLayout ? classes.panelSummaryNewLayout : classes.panelSummary;
  let panelContainer = classNewLayout ? classes.panelContainerNewLayout : classes.panelContainer;
  let divider = classNewLayout ? classes.dividerNewLayout : classes.divider;
  if (!price.balanceDue > 0 && classNewLayout) {
    heading = classes.headingPaidInFull;
    viewPanel = classes.viewPanel;
    panelSummary = classes.panelSummaryFullPaid;
    panelContainer = classes.panelContainer;
    divider = classes.divider;
  }
  return { column, heading, viewPanel, root, panelSummary, panelContainer, divider };
};

const PaymentHistory = (props) => {
  const {
    renderContent,
    data: { localizedDayjs },
  } = useGlobal();
  const classes = useStyles();

  function renderCardType(type) {
    switch (type) {
      case 'AX':
        return <AmericanExpress />;
      case 'DC':
        return <DinersClub />;
      case 'DS':
        return <Discover />;
      case 'JC':
        return <Jcb />;
      case 'MC':
        return <MasterCard />;
      case 'VA':
        return <Visa />;
      default:
        return '';
    }
  }
  const { price, paymentHistoryData, classNewLayout, paymentBalanceFar, from } = props;
  const classSelected = setClasses(classNewLayout, classes, price);
  const expanded = !classNewLayout || price.balanceDue === 0;

  return (
    <div className={classSelected.root}>
      <Accordion defaultExpanded={expanded} className={classSelected.panelContainer}>
        <AccordionSummary
          className={classSelected.panelSummary}
          expandIcon={<ExpandMoreIcon color="primary" className={classes.expandIcon} />}
          aria-controls="panel-content"
          id="panel-header">
          <Box className={classSelected.heading}>
            {!classNewLayout ? (
              <Typography className="panelTitle">
                {renderContent('paymentBookingAmendPaymentHistory', 'Payment History')}
              </Typography>
            ) : (
              price.balanceDue > 0 && (
                <Typography className={classes.panelTitleBalance}>
                  {renderContent('paymentBookingAmendPaymentHistoryPaid', `You’ve paid`)}
                  <b>{` ${paymentBalanceFar} `}</b>
                  {renderContent(
                    'paymentBookingAmendPaymentHistoryBalance',
                    `of your balance so far.`,
                  )}
                </Typography>
              )
            )}
            {!classNewLayout ? (
              <Typography className={classSelected.viewPanel}>
                {renderContent('paymentBookingAmendViewLabel', 'View')}{' '}
                <Hidden xsDown>
                  {renderContent('paymentBookingAmendPaymentHistory', 'Payment History')}
                </Hidden>
              </Typography>
            ) : (
              <Typography className={classSelected.viewPanel}>
                {renderContent('paymentBookingAmendViewLabel', 'View')}{' '}
                {renderContent('paymentBookingAmendPaymentHistory', 'Payment History')}
              </Typography>
            )}
          </Box>
        </AccordionSummary>
        <Divider className={classSelected.divider} />
        <AccordionDetails className={classes.details}>
          <div className={clsx(classSelected.column, classes.helper)}>
            <div className="content-history">
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHead}>
                      {renderContent('paymentBookingAmendPaymentDate', 'Payment date')}
                    </TableCell>
                    <TableCell className={classes.tableHead} align="left">
                      {renderContent('paymentBookingAmendAmount', 'Amount')}
                    </TableCell>
                    <TableCell
                      className={classes.tableHead}
                      align={from === 'payment-page' ? 'right' : 'left'}>
                      {from === 'payment-page' && (
                        <div className={classes.tableHeadWrapper}>
                          {renderContent('paymentBookingAmendPaymentType', 'Payment type')}
                        </div>
                      )}
                      {from !== 'payment-page' && (
                        <Box className="iconHeader">
                          <span className={classes.creditCarardIcon}>
                            <CreditCarardIcon />
                          </span>
                          {renderContent('paymentBookingAmendType', 'Type')}
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentHistoryData &&
                    paymentHistoryData.map((payment) => (
                      <TableRow key={payment} className={classes.row}>
                        <TableCell className={classes.tableCell} component="th" scope="row">
                          {localizedDayjs(payment.date).format('MMM D, YYYY')}
                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          {formatPrice(payment.amount, price.currencyCode, true, true, true)}
                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          <Box className="iconHeader">
                            <span
                              className={clsx(
                                classes.creditCarardIcon,
                                from === 'payment-page' && classes.creditCarardIconPaymentPage,
                              )}>
                              {renderCardType(payment.type)}
                            </span>
                          </Box>
                        </TableCell>
                        <TableCell align="left" />
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PaymentHistory;
